const Success = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            height="26"
            width="26"
            viewBox="0 0 26 26"
            {...props}
        >
            <circle cx="13" cy="13" r="13" fill="#4FB477" />
            <path
                fill="#4FB477"
                d="M13 0C5.828 0 0 5.828 0 13s5.828 13 13 13 13-5.828 13-13S20.172 0 13 0zm0 1.3c6.47 0 11.7 5.23 11.7 11.7 0 6.47-5.23 11.7-11.7 11.7-6.47 0-11.7-5.23-11.7-11.7C1.3 6.53 6.53 1.3 13 1.3z"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M18.942 10.442L12 17.384l-4.442-4.442.884-.884L12 15.616l6.058-6.058.884.884z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export default Success
